<template>
  <div class="pop-area" id="popup-container" v-if="exampleVisible" @click.self="exampleOpen">
    <div class="popup">
      <div class="pop-header">
        <h3 class="tit">작성예시</h3>
        <button type="button" class="close" @click="$emit('update:exampleVisible', !exampleVisible)">닫기</button>
      </div>
      <div class="desc-area">
        <h4 class="desc-tit">&nbsp;</h4>
        <div class="desc-column">
          <span class="tit">제보 제목</span>
          <div class="desc">
            3년동안 돈을 갚지않는 동아OO회사의 직원을 고발합니다.
          </div>
        </div>
        <div class="desc-column">
          <span class="tit">제보일</span>
          <div class="desc">
            {{ today }}
          </div>
        </div>
        <div class="desc-column">
          <span class="tit">제보 내용</span>
          <div class="desc-container">
            <div class="desc" style="float:none;overflow:auto">
                <p class="content"><br>[누가]<br></p><span class="txt">이름은 홍길동부장이고, 당시에는 동아OO회사의 XX팀에 근무하였음.</span>
                <p class="content"><br>[언제]<br></p><span class="txt">2019년 1월말경임.(설연휴 전 1/21~25경으로 예상함.)</span>
                <p class="content"><br>[어디서]<br></p><span class="txt">서울 송파구 장지동 스타OO(서울 송파구 OO동 100. OO쇼핑몰 지하1층 위치) 커피전문점에서 만났음.</span>
                <p class="content"><br>[무엇을]<br></p><span class="txt">사무용품 공급대금 2,500,000원을(단가5,000*500ea) 차용함.</span>
                <p class="content"><br>[어떻게]<br></p><span class="txt">회사에서 입금해준 2,500,000만원을 15일간만 차용하기로 한 조건으로 현금으로 인출하여 전달하였음. 향후에 추가 소모품을 (년 1,000만원 이상) 구매하기로 구두약속을 하였음.</span>
                <p class="content"><br>[왜]<br></p><span class="txt">최초 15일 아니라 수개월이 지나도 원금을 1만원도 갚지 않고 있음.<br>뿐만 아니라 구두 약속한 추가 물품도 거래실적이 0건임.<br>'19년 8월 이후에는 전화연락도 되지 않음.<br>소문에는 아직 근무하고 있고, 유흥을 좋아해 유흥 빚이 많다고 들었음</span>
                <p class="content"><br>[기타 요청사항]<br></p><span class="txt">사실 관계를 확인하여 조사해 주시고, 규정과 원칙대로 처리하여 일벌백계해 주시기 바랍니다.</span>
            </div>
          </div>
        </div>
      </div>
      <div class="chk-btn-area">
        <button type="button" class="default-btn chk-btn" @click="$emit('update:exampleVisible', !exampleVisible)">확인</button>
      </div>
    </div>
  </div>
</template>
<style lang="scss">
@import '../css/sub.scss';
</style>
<script>
export default {
  name: 'ExampleWriting',
  props: {
    exampleVisible: {
      type: Boolean,
      require: true,
      default: false
    }
  },
  data () {
    return {
      today: ''
    }
  },
  created () {
    this.popDefault()
  },
  methods: {
    exampleOpen () {
      this.$emit('update:visible', false)
    },
    popDefault () {
      const date = new Date()
      let yy = date.getFullYear()
      let mm = date.getMonth() + 1
      let dd = date.getDate()
      if (dd < 10) {
        dd = '0' + dd
      }
      if (mm < 10) {
        mm = '0' + mm
      }
      this.today = yy + '-' + mm + '-' + dd
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ExampleWriting.vue